import React from 'react';
import PropTypes from 'prop-types';
import { TextareaAutosize } from '@material-ui/core';
import cx from 'classnames';

const MyTextareaAutosize = React.forwardRef(({ classes, className, ...props }, ref) => (
  <div className={classes.root}>
    <TextareaAutosize className={cx(classes.textArea, className)} ref={ref} {...props} />
  </div>
));

MyTextareaAutosize.propTypes = {
  classes: PropTypes.shape({}),
  className: PropTypes.string,
};

MyTextareaAutosize.defaultProps = {
  classes: {},
};

export default MyTextareaAutosize;
